import {
  convertToTimeZone,
  dateFormatter,
  getEventImageUrl,
} from "../../../utils/Helper";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import useHttpHook from "../../../Hooks/HttpHook";
import { AddToWishlist, RemoveFromWishlist } from "../../../utils/ApiConstant";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { showErrorToast } from "../../../utils/notify";

const Event = (props) => {
  const [loading, sendRequest, error] = useHttpHook();
  const navigate = useNavigate();
  const location = useLocation();
  const { userDetails } = useSelector((state) => state.user);

  const [wishlisted, setWishlist] = useState(props.wishlist?.length > 0);
  const [timezone, setTimeZone] = useState(null);

  const imageUrl = getEventImageUrl(
    props.mainimage,
    "https://placehold.co/700x900/0b1020/eaf0ff?text=Event"
  );

  const wishlistAction = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const path = wishlisted ? RemoveFromWishlist : AddToWishlist;
    const wishlist = await sendRequest(path, {
      method: "post",
      data: { eventId: props.Id },
    });
    if (wishlist.status === 1) {
      setWishlist(!wishlisted);
    }
  };

  useEffect(() => {
    setTimeZone(
      convertToTimeZone(
        new Date(props.eventTiming.startDate || new Date()),
        props.eventTiming.timeZone || "Asia/Calcutta"
      )
    );
  }, [props.eventTiming]);

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);

  const eventDetails = (e) => {
    e.preventDefault();
    if (location.pathname === `/${props?.userName}/userPromotingEvents`) {
      navigate(
        `/${props.userName}/event-details/${props.Id}?referralId=${props?.userProfile?._id}&eventId=${props.Id}&userId=${props?.userName}`
      );
    } else if (location.pathname === `/promoter/events`) {
      navigate(
        `/event-details/${props.Id}?referralId=${userDetails?._id}&eventId=${props.Id}`
      );
    } else {
      navigate(`/event-details/${props.Id}?redirectUrl=${location.pathname}`);
    }
  };

  const startLabel = timezone
    ? `${dateFormatter(props.eventTiming.startDate)} (${timezone})`
    : dateFormatter(props.eventTiming.startDate);

  const endLabel =
    props.eventTiming.eventDayType === "multi"
      ? `${dateFormatter(props.eventTiming.endDate)} (${timezone})`
      : startLabel;

  if (props.layout === "my-events") {
    return (
      <article className="event-my-event-card" role="listitem" aria-label={props.title}>
        <div className="event-my-event-card-media-wrap">
          <a
            className="event-my-event-card-media-link"
            href={`/event/event-details/${props.Id}`}
            aria-label={`View ${props.title}`}
            onClick={eventDetails}
          >
            <div className="event-my-event-card-media">
              <img
                className="event-my-event-card-image-bg"
                src={imageUrl}
                alt=""
                loading="lazy"
                aria-hidden="true"
              />
              <img
                className="event-my-event-card-image"
                src={imageUrl}
                alt=""
                loading="lazy"
              />
            </div>
          </a>
          <button
            className={`event-my-event-fav${wishlisted ? " is-active" : ""}`}
            type="button"
            disabled={loading}
            aria-label={wishlisted ? "Remove from wishlist" : "Add to wishlist"}
            onClick={wishlistAction}
          >
            <i className={`bi ${wishlisted ? "bi-heart-fill" : "bi-heart"}`} aria-hidden="true"></i>
          </button>
          <span className="event-my-event-tag">{props.category}</span>
        </div>
        <a
          className="event-my-event-card-body-link"
          href={`/event/event-details/${props.Id}`}
          onClick={eventDetails}
        >
          <div className="event-my-event-card-body">
            <div className="event-my-event-dates">
              <div>Start Date : {startLabel}</div>
              {props.eventTiming.eventDayType === "multi" && (
                <div>End Date : {endLabel}</div>
              )}
            </div>
            <h2 className="event-my-event-title">{props.title}</h2>
            <div className="event-my-event-location">
              <i className="bi bi-geo-alt" aria-hidden="true"></i>
              <span>{props.location?.address}</span>
            </div>
          </div>
        </a>
      </article>
    );
  }

  return (
    <article className="event-card" role="listitem" aria-label={props.title}>
      <a className="event-card-link" href={`/event/event-details/${props.Id}`} onClick={eventDetails}>
        <div className="event-card-media-wrap">
          <img className="event-card-media-bg" src={imageUrl} alt="" loading="lazy" aria-hidden="true" />
          <img className="event-card-media" src={imageUrl} alt="" loading="lazy" />
        </div>
        <div className="event-card-body">
          <div className="event-card-top">
            <span className="event-chip">{props.category}</span>
            <button
              className={`event-fav${wishlisted ? " is-active" : ""}`}
              type="button"
              disabled={loading}
              aria-label={wishlisted ? "Remove from wishlist" : "Add to wishlist"}
              onClick={wishlistAction}
            >
              <i className={`bi ${wishlisted ? "bi-heart-fill" : "bi-heart"}`} aria-hidden="true"></i>
            </button>
          </div>
          <h2 className="event-card-title">{props.title}</h2>
          <div className="event-card-meta">
            <div className="event-card-meta-row">
              <i className="bi bi-calendar3" aria-hidden="true"></i>
              <div className="event-card-meta-copy">
                <div>
                  <strong>Start Date:</strong> {startLabel}
                </div>
                {props.eventTiming.eventDayType === "multi" && (
                  <div>
                    <strong>End Date:</strong> {endLabel}
                  </div>
                )}
              </div>
            </div>
            <div className="event-card-meta-row">
              <i className="bi bi-geo-alt" aria-hidden="true"></i>
              <div className="event-card-meta-copy">{props.location?.address}</div>
            </div>
          </div>
        </div>
      </a>
    </article>
  );
};

export default Event;
